import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";
import { Link } from "react-router-dom";
export default function AscenseursMonteChargesView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Ascenseurs & Monte-charges</h1>
            <p>
              (VERATRACT-SAFETY) propose des prestations complètes de
              contrôle réglementaire des ascenseurs, monte-charges et équipements mixtes,
              afin d’assurer la sécurité des usagers, la conformité et la disponibilité
              des installations.
            </p>

            <div className="prs-hero__bullets">
              <span>🧩 Essais de réception</span>
              <span>🔁 Visites périodiques</span>
              <span>✅ Conformité & sécurité usagers</span>
            </div>

            <a href="#contact" className="btn-primary">Demander une inspection</a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/ascenseurs/1.jpg" alt="Contrôle d’ascenseur" /></div>
              <div><img src="/images/ascenseurs/2.jpg" alt="Monte-charge industriel" /></div>
              <div><img src="/images/ascenseurs/3.jpg" alt="Vérification portes palières" /></div>
              <div><img src="/images/ascenseurs/2.jpg" alt="Équipement de levage vertical" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== CONTENU RÉGLEMENTAIRE ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Pourquoi réaliser le contrôle ?</h2>
          <p>
            Le contrôle des ascenseurs et monte-charges vise à prévenir les accidents
            liés à la rupture de câbles, au relâchement du frein, aux défaillances
            du système de commande, à l’arrêt imprécis aux étages, ou encore aux
            dysfonctionnements des portes palières.  
            L’objectif est de <strong>protéger les usagers</strong> et de
            <strong>préserver les biens matériels</strong>, notamment dans les
            immeubles d’habitation et logements sociaux.
          </p>

          <div className="prs-columns">
            <article>
              <h3>Textes rendant le contrôle obligatoire</h3>
              <ul>
                <li>Arrêté du 9 avril 1953</li>
                <li>Code du travail</li>
                <li>Arrêtés et circulaires ministériels</li>
              </ul>
            </article>

            <article>
              <h3>Autorité compétente</h3>
              <p>
                <strong>Ministère de l’Équipement et du Transport</strong> — chargé de l’application
                et du contrôle de la réglementation en vigueur.
              </p>
            </article>
          </div>

          <article>
            <h3>Équipements concernés</h3>
            <p>
              Tous les <strong>ascenseurs pour personnes</strong> ainsi que les
              <strong> monte-charges</strong> et <strong>équipements mixtes</strong>
              (ascenseurs de service).
            </p>
          </article>

          <article>
            <h3>Obligations réglementaires</h3>
            <ul>
              <li><strong>Essais de réception</strong> : avant mise en service ou après travaux significatifs.</li>
              <li><strong>Visites périodiques</strong> : à réaliser <strong>annuellement</strong> ou <strong>semestriellement</strong>, selon l’usage et le contexte.</li>
            </ul>
          </article>

          <article>
            <h3>Documents recommandés à l’achat</h3>
            <p>
              À défaut d’exigences spécifiques prévues par la réglementation marocaine,
              il est fortement conseillé d’exiger :
            </p>
            <ul>
              <li>le <strong>manuel d’entretien et de sécurité</strong> ;</li>
              <li>le <strong>registre d’entretien réglementaire</strong> de l’installation.</li>
            </ul>
          </article>

          <div className="prs-team">
            
            
          </div>

          <div className="prs-btns">
            <a className="btn-primary" href="#contact">Faire une consultation</a>
            
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
